import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

// import ConstantsList from '../../../common/Constants';

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";
import {
  addPoDetailNumber,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import {
  currencyFormat,
  formatDateWithAMPM,
} from "../../../../common/Validations";
// import Moment from "react-moment";
// import configFromEnv from "../../../../services/configuration";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import POInvoiceUploadModal from "./POInvoiceUploadModal";
import ServicePoPrint from "./ServicePoPrint";
import { useReactToPrint } from "react-to-print";
// import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import { SearchField } from "../../../../Components/formElements/SearchField";

const ServicePurchaseOrderList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Service Order");
  let purchase_orderData = useSelector(
    (state) => state?.purchasing?.purchase_order?.service_po?.data,
  ); // User Details from Store
  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.pagination,
  ); // User Details from Store
  let userData = useSelector((state) => state?.user); // User Details from Store

  // Format the price above to USD using the locale, style, and currency.
  // let USDollar = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",
  // });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [totalRows, setTotalRows] = useState(10);
  // const [perPage, setPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line
  const showUploadInvoice = (purchasingDocumentNr) => {
    let obj = {
      purchasingDocumentNr,
    };
    setModalEditInvoice(true);
    setInvoiceData(obj);
  };
  const hideUploadInvoiceModal = () => {
    setModalEditInvoice(false);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  // /* Modal Function */
  // const createRFQ = () => {
  //   setModalShow(true);
  // };

  const hideModal = () => {
    setModalShow(false);
  };

  const detailedPage = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_DETAILS);
  };
  const fetchUsers = async (page) => {
    setLoading(true);
    // const response = await axios.get(`https://reqres.in/api/users?page=${page}&per_page=${perPage}&delay=1`);

    setData(purchase_orderData);
    // setTotalRows(purchase_orderData?.length);
    setLoading(false);
  };
  useEffect(() => {
    const loadServicePo = () => {
      let servicePO = {
        queryName: "getServicePO",
        module: "PO",
      };
      dispatch(getServicePO(servicePO));
    };
    loadServicePo();
    // eslint-disable-next-line
  }, []);

  // const handlePageChange = (page) => {
  //   fetchUsers(page);
  // };

  // const handlePerRowsChange = async (newPerPage, page) => {
  //   setLoading(true);
  //   // const response = await axios.get(`https://reqres.in/api/users?page=${page}&per_page=${newPerPage}&delay=1`);

  //   setData(purchase_orderData);
  //   setPerPage(perPage);
  //   setLoading(false);
  // };

  useEffect(() => {
    fetchUsers(1); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchase_orderData]);

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    /* {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row.vendorCode)}
              title="Chat With the User"
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    }, */
    {
      name: "Date",
      selector: (row) => formatDateWithAMPM(row?.createdAt) || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-medium">
            {formatDateWithAMPM(row.createdAt)}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Document/Purchase Type",
      selector: (row) => row.purchasingDocumentCode,
      sortable: true,
      width: "260px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchasingDocumentType} </p>
          <p className="m-0 p-0 pt-1">{row.purchaseType} </p>
        </div>
      ),
    },

    {
      name: "Document",
      id: "purchasingDocumentNr",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
      {
      name: "Update",
      cell: (row) => (
        <button
          className="btn btnInfo d-flex  flex-row justify-content-center"
          disabled={
            !(row.statusHeader === "New" || row.statusHeader === "Rejected")
          }
          onClick={() =>
            updatePage(row.purchasingDocumentNr, row?.purchasingDocumentType)
          }
        >
          <i class="bi bi-pencil-square mx-2"></i> Edit
        </button>
      ),
      width: "150px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "100px",
    },

    /*   {
      name: "Upload INV",
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => showUploadInvoice(row.purchasingDocumentNr)}
          >
            Upload
          </button>
        </>
      ),
      width: "120px",
    }, */

    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    // {
    //   name: "Version",
    //   selector: (row) => row.version || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Status",
      id: "statusHeader",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.statusHeader} />
        </>
      ),
      width: "180px",
    },
    // {
    //   name: "Date",
    //   id:"purchasingDocumentDate",
    //   // range:true,
    //   month:true,
    //   selector: (row) => row.purchasingDocumentDate,
    //   sortable: true,
    //   cell: (row) => (
    //     <span>
    //       {formatDate(row.purchasingDocumentDate)}
    //     </span>
    //   ),
    //   width: "110px",
    //   style: {
    //     textAlign: "right",
    //   },
    //   headerStyle: {
    //     textAlign: "right",
    //   },
    // },
    {
      name: "PO Value",
      cell: (row) => (
        <div>
          <p className="numberFormate m-0 p-0 pt-1 fw-bold">
            {currencyFormat(Number(row.purchasingDocumentValue).toFixed(2))}
          </p>
          <span className="text-primary fw-bold">INR</span>
        </div>
      ),
      selector: (row) => row.purchasingDocumentValue || "--",
      sortable: true,
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },
    /*     {
      name: "Created Date",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
        {formatDateWithAMPM(row?.createdAt)}
        </>
        // <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
        //   {row.createdAt}
        // </Moment>
      ),
      sortable: true,
      width: "160px",
    }, */
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    // {
    //   name: "Schedule Nr",
    //   cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
    //   width: "180px",
    // },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Net Value",
      cell: (row) => <span>{row.netValue} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    // {
    //   name: "Purchase Req.",
    //   cell: (row) => <span>{row.requestNumber} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Purchase Req. Item Nr",
    //   cell: (row) => <span>{row.prItemNr} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Item Number",
    //   cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
    //   width: "180px",
    // },
    // {
    //   name: "Material",
    //   cell: (row) => <span>{row.materialCode} </span>,
    //   width: "180px",
    // },
    // {
    //   name: "Material Desc",
    //   cell: (row) => <span>{row.materialDescription} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Material Group",
    //   cell: (row) => <span>{row.materialGroup} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Quantity",
    //   cell: (row) => <span>{row.purchaseQuantity} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "UOM",
    //   cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Delivery Date",
    //   cell: (row) => <span>{row.deliveryDate} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "PR",
    //   cell: (row) => <span>{row.requestNumber || "-"} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "PR Item",
    //   cell: (row) => <span>{row.prItemNr || "-"} </span>,
    //   width: "220px",
    // },
  ];

  const handleSuccessData = async (data) => {

    // await ItemService.updateDispatchInvoice(data).then((item) => {
    //   // console.log(">> item! title", item);
    //   if (item?.status === 200) {
    //     handleSearchFuncApi();
    //   } else {
    //     console.log(">> Error: Loading getMasterDataSelf");
    //   }
    // });
  };

  //service po print invocie
  const contentRef = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level
  const handlePrint = useReactToPrint({
    contentRef,
    // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  });

  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);

    // Wait for state updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  //toggle chat

  // const toggleChat = (groupId) => {
  //   // Toggle the same PR closes the chat
  //   if (chatId === groupId) {
  //     setChatId(null);
  //   } else {
  //     setChatId(groupId);
  //   }
  // };
  //filter
  const [filterShow, setFilterShow] = useState(false);
  const handleFilterData = async (filters) => {
    //  let servicePO = {
    //     queryName: "getServicePO",
    //     module: "PO",
    //   };
    const obj = {
      queryName: "getServicePO",
      module: "PO",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };
    dispatch(getServicePO(obj));
  };

  // const columnsForFilter = columns
  //   .filter((col) => col.id || col.selectorKey)
  //   .map((col) => ({
  //     name: col.name,
  //     selectorKey: col.id || col.selectorKey,
  //     dropDown: col.dropDown || false,
  //     range: col.range || false,
  //     month: col.month || false,
  //   }));

  const columnsForFilter = [
  {
      id: "vendorName",
      name: "Vendor",
      selectorKey: "vendorName",
 
    },
    {
      id: "statusHeader",
      name: "Status",
      selectorKey: "statusHeader",
      
    },
    {
      id: "vendorName",
      name: "Vendor Name",
      selectorKey: "vendorName",
    
    },
    {
      id: "purchasingDocumentDate",
      name: "Date",
      selectorKey: "purchasingDocumentDate",
      month: true,
    },
    {
      id: "statusHeader",
      name: "Status",
      selectorKey: "statusHeader",
      
    },
    {
      id: "purchasingDocumentValue",
      name: "PO Value",
      selectorKey: "purchasingDocumentValue",
      numberRange: true,
    },
  ];


  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const handlePageChange = (page) => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: page,
      per_page: getNewPerPage,
      // vendorCode: userData?.data?.userId,
      // role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };

    dispatch(getServicePO(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: page,
      per_page: newPerPage,
      vendorCode: userData?.data?.userId,
      role: userData?.data?.roles?.length > 0 ? userData?.data?.roles[0] : "",
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getServicePO(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getServicePO(obj));
  };

  //Common Search Function
   const updatePage = (poNumber, purchasingDocumentType) => {
      dispatch(addPoDetailNumber(poNumber));
      navigate(CustomerConstants.CUSTOMER_V5_PURCHASE_ORDER_UPDATE);
    };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Service Purchase Order</h2>
                <p className="subText">
                  Lists of Service Purchase Order and details
                </p>
              </Col>

              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>

              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SR</span>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                      <span className="headerTitle">Service PO List</span>
                      <span className="subHeaderTitle">
                        View of Service PO and Status{" "}
                      </span>
                    </Col>

                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i> Change Buyer
                      </button>
                    </Col> */}
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      {/* <Col
                        xs={5}
                        md={5}
                        lg={5}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={() => createRFQ()}
                        >
                          <i className="bi bi-plus-lg"></i> Request Supplier for
                          ACK
                        </button>
                      </Col> */}
                      <Col
                        xs={5}
                        md={5}
                        lg={5}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={() => {
                            alert("asd");
                          }}
                        >
                          <i className="bi bi-x-circle"></i> Cancel
                        </button>
                      </Col>
                      <Col xs={2} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 5]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <div style={{ display: "none" }}>
          <ServicePoPrint ref={contentRef} data={getLoadingAdvice} />
        </div>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />

      <POInvoiceUploadModal
        show={getModalEditInvoice}
        onHide={() => hideUploadInvoiceModal()}
        invoiceinfo={invoiceData}
        onsuccessdata={handleSuccessData}
        // viewInvoiceData={viewInvoiceData}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default ServicePurchaseOrderList;
